import type { OrderActionType } from 'state/secondaryMarket/shared/actions';
import { secondaryMarketCancellationActionsFactory } from 'state/secondaryMarket/shared/cancellation/cancellation.actions';
import type { Thunk } from 'state/state.common';
import type { HttpError } from 'utils/http/httpClient.model';
import { extractHttpErrorMessage, isServerError } from 'utils/http/httpClient.model';

export const cancellationThunksFactory = <CancelResponse>(actionType: OrderActionType) => {
  const actions = secondaryMarketCancellationActionsFactory<CancelResponse, OrderActionType>(actionType);
  return {
    orderCancellationErrorsThunk:
      (orderId: string, error?: HttpError): Thunk<void> =>
      dispatch => {
        const message = extractHttpErrorMessage(error);
        if (isServerError(error)) {
          dispatch(actions.secondaryMarketCancellationFailed(orderId, message));
        } else {
          dispatch(actions.secondaryMarketCancellationRejected(orderId, message));
        }
      },
  };
};
